import { InlineLink } from '@utilitywarehouse/hearth-react';
import { ReactNode } from 'react';

interface FAQLinkProps {
  href: string;
  children: ReactNode;
}

const FAQLink = ({ href, children }: FAQLinkProps) => (
  <InlineLink href={href} rel="noreferrer noopener" target="_blank">
    {children}
  </InlineLink>
);

export { FAQLink };
